var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoAgentFlower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M0 90L90 90 90 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__c",
    d: "M0.205 0L3.897 0 3.897 3.693 0.205 3.693z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#prefix__b)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#172D20",
    d: "M10.353 90h-1.28c.004-4.521.288-16.544 2.817-29.444 1.078-5.502 2.417-10.346 3.98-14.4 1.776-4.608 3.848-8.2 6.16-10.68l1.114.385c-4.243 4.551-7.695 13.123-9.981 24.789-2.521 12.857-2.805 24.843-2.81 29.35",
    transform: "translate(17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#172D20",
    d: "M11.616 36.746C7.245 32.57.279 32.769.279 32.769s.12 6.968 4.492 11.143c4.37 4.175 11.337 3.977 11.337 3.977s-.121-6.968-4.492-11.143M18.075 54.534c5.176-3.122 11.931-1.41 11.931-1.41S28.37 59.9 23.192 63.02c-5.176 3.122-11.931 1.41-11.931 1.41s1.638-6.775 6.814-9.896",
    transform: "translate(17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0076BC",
    d: "M38.921 20.619C34.79 29.236 24.074 32.69 24.074 32.69s-4.016-10.517.115-19.135C28.321 4.938 39.037 1.483 39.037 1.483s4.016 10.518-.116 19.136",
    transform: "translate(17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0076BC",
    d: "M26.036 13.656c3.172 9.016-1.962 19.035-1.962 19.035s-10.277-4.597-13.45-13.612C7.454 10.063 12.588.044 12.588.044S22.864 4.64 26.036 13.656",
    transform: "translate(17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0076BC",
    d: "M43.109 34.653c-9.016 3.172-19.035-1.962-19.035-1.962s4.597-10.277 13.613-13.449c9.015-3.172 19.034 1.962 19.034 1.962s-4.597 10.278-13.612 13.45",
    transform: "translate(17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#172D20",
    d: "M23.654 32.49c.272.126.42.201.42.201s-.058-.154-.152-.431c-.747-2.033-4.33-10.777-11.92-14.416-.642-.307-1.294-.565-1.951-.787.15.676.338 1.352.574 2.022 2.79 7.927 11.07 12.438 13.029 13.411M23.922 32.26c.101.275.152.431.152.431s.068-.15.201-.42c.918-1.985 4.55-10.687 1.76-18.615-.234-.67-.51-1.315-.817-1.936-.374.585-.72 1.194-1.029 1.836-3.639 7.59-.958 16.65-.267 18.704",
    transform: "translate(17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8D375",
    d: "M23.922 32.26c.094.277.152.431.152.431s-.05-.156-.152-.431M24.225 33.122c-.093-.277-.151-.43-.151-.43s.05.155.151.43",
    transform: "translate(17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#172D20",
    d: "M24.505 32.54c-.275.1-.431.15-.431.15s.15.07.419.203c1.986.917 10.688 4.55 18.616 1.76.67-.236 1.315-.51 1.936-.818-.585-.373-1.194-.72-1.836-1.028-7.59-3.64-16.651-.958-18.704-.268",
    transform: "translate(17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#172D20",
    d: "M24.275 32.271c-.126.273-.202.42-.202.42s.155-.058.432-.152c2.034-.746 10.777-4.33 14.416-11.92.307-.642.565-1.294.787-1.951-.676.15-1.352.338-2.021.574-7.928 2.789-12.438 11.071-13.412 13.03",
    transform: "translate(17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8D375",
    d: "M24.505 32.54c-.277.093-.431.15-.431.15s.156-.05.431-.15M24.275 32.271c-.133.269-.202.42-.202.42s.076-.147.202-.42M24.493 32.892c-.268-.133-.42-.2-.42-.2s.148.074.42.2M23.642 32.843c.279-.094.431-.152.431-.152s-.155.05-.43.152",
    transform: "translate(17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8D375",
    d: "M24.074 32.691s-.147-.075-.42-.2c.269.133.42.2.42.2",
    transform: "translate(17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8D375",
    d: "M23.873 33.11c.133-.268.2-.42.2-.42s-.075.149-.2.42",
    transform: "translate(17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#172D20",
    d: "M20.973 31.204c.82-1.713 2.875-2.436 4.588-1.615 1.712.822 2.435 2.877 1.615 4.589-.822 1.713-2.876 2.436-4.59 1.615-1.712-.822-2.435-2.876-1.613-4.589",
    transform: "translate(17)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17) translate(23.25)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#172D20",
    d: "M3.715 2.644c-.44.92-1.543 1.308-2.462.867-.92-.44-1.306-1.543-.866-2.463C.827.128 1.93-.259 2.849.182c.919.44 1.307 1.543.866 2.462",
    mask: "url(#prefix__d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#172D20",
    d: "M49.02 13.218c-.442.92-1.544 1.307-2.463.866-.92-.44-1.307-1.543-.866-2.462.44-.92 1.542-1.307 2.462-.866.919.44 1.307 1.543.866 2.462",
    transform: "translate(17)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAgentFlower);
export default __webpack_public_path__ + "static/media/no-agent-flower.55b7af7ff4ec69a4b532dbba7ba8fee2.svg";
export { ForwardRef as ReactComponent };